export const openSubMenu = () => {

    const menuActions = (event, component, isKeyboard) => {
        event.stopPropagation();
        const siblingUl = component.nextElementSibling;

        // Clear all menus
        closeAllOpenMenus();

        setExpanded(component, true);
        siblingUl.classList.add('nav-submenu__list--open');
        component.focus();

        const firstChild = siblingUl.querySelector('.nav-submenu__list--open .sub-nav-menu-container .nav-submenu__item:first-of-type a');
        const firstInput = siblingUl.querySelector('.nav-submenu__list--open .sub-nav-menu-container .dropdown__input');

        // Determine what to focus
        if (firstChild) {
            firstChild.addEventListener('keydown', handleShiftTab(siblingUl));
            isKeyboard && !isMobile() && firstChild.focus();
        }
        if (firstInput) {
            firstInput.addEventListener('keydown', handleShiftTab(siblingUl));
            isKeyboard && !isMobile() && firstInput.focus();
        }

        if (isMobile()) {
            const backButton = siblingUl.querySelector('.nav-submenu__back-bar-link');
            siblingUl.addEventListener('transitionend', (e) => {
                if (e.propertyName === 'left') {
                    backButton.focus();
                }
            }, { once: true });
        }

        // Listen for Esc/click-off to dismiss
        document.addEventListener('click', handleClickOff(component));
        document.addEventListener('keydown', handleEscape);
    };

    // Utilities
    const isMobile = () => window.innerWidth <= 767;

    const removeEventListeners = (component) => {
        document.removeEventListener('click', handleClickOff(component));
        document.removeEventListener('keydown', handleEscape);
    };

    const setExpanded = (component, value) => {
        component.setAttribute('aria-expanded', value);
    }

    const closeCurrentOpenMenu = (component) => {
        const siblingUl = component.nextElementSibling;
        siblingUl.classList.remove('nav-submenu__list--open');
        removeEventListeners(component);
        setExpanded(component, false);
        if (isMobile()) {
            component.focus();
        }
    }

    const closeAllOpenMenus = () => {
        const openMenus = document.querySelectorAll('.nav-submenu__list--open');
        openMenus.forEach(menu => {
            menu.classList.remove('nav-submenu__list--open');
            const trigger = document.querySelector(`[aria-controls="${menu.id}"]`);
            if (trigger) {
                setExpanded(trigger, false);
                removeEventListeners(trigger);
                trigger.focus();
            }
        });
    }

    const handleClickOff = (component) => (event) => {
        if (isMobile()) {
            return;
        }

        const siblingUl = component.nextElementSibling;
        if (!siblingUl.contains(event.target) && event.target !== component) {
            closeCurrentOpenMenu(component);
        }
    };

    // Event handlers
    const handleClick = (event) => {
        event.preventDefault();
        const component = event.currentTarget;
        menuActions(event, component, false);
    }

    const handleKeys = (event) => {
        const component = event.currentTarget;

        if (event.key == 'Enter' || event.key == ' ') {
            event.preventDefault();
            menuActions(event, component, true);
        }
    }

    const handleEscape = (event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            closeAllOpenMenus();
        }
    }

    const handleShiftTab = (container) => (event) => {
        if (isMobile()) {
            return;
        }

        if (event.key == 'Tab' && event.shiftKey) {
            const lastChildren = container.querySelectorAll('.nav-submenu__list--open .sub-nav-menu-container .nav-submenu__item:last-of-type a');
            event.preventDefault();
            lastChildren[lastChildren.length - 1].focus();
        }
    }

    const init = (component) => {
        component.addEventListener('click', handleClick);
        component.addEventListener('keydown', handleKeys);
    };

    return {
        init: init,
        selector: '.menu-bar-link'
    };
};
